import { Component, Input, Output, SimpleChange, OnInit, OnChanges, EventEmitter, ViewChild} from '@angular/core';
import { CstGrpModel, CstModel } from '../../../../services/index';
import { CnsltnQuotCstModel, FareService, CostItemModel, CrncyRateModel, CnsltnReqModel, CrgoLstModel } from '../../../../services/index';
import { RequestOptionsArgs } from '@angular/http';
import { SelectItem, SelectComponent } from 'ng2-select';
import * as bigdecimal from 'bigdecimal';
import { Util } from '../../../../utils/index'
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
    selector:'fare-rate-detail-list',
    templateUrl: 'fare-rate-detail-list.html',
    inputs: ['fareTypeNm', 'cnsltnReq', 'cnsltnReqAdrs', 'fareTypeCd', 'cargoSeq']
})


export class FareRateDetailList implements OnInit {
  
  private _cnsltnQuotCstList: Array<CnsltnQuotCstModel> = new Array<CnsltnQuotCstModel>();
  private fareTypeNm: string;
  private fareTypeCd: number;
  private _costItemList:Array<CostItemModel> = new Array<CostItemModel>();
  private costItemNmList:Array<any> = new Array<any>();
  private _crncyRateList:Array<CrncyRateModel>;
  private crncyCdList:Array<any> = new Array<any>();
  private cnsltnReq:CnsltnReqModel;
  private _itemUnitList:Array<any> = new Array<CostItemModel>() ;
  private cnsltnReqAdrs:string;
  private cargoSeq:number;

  @Input() set costItemList(costItemList:Array<CostItemModel>) {
    if(!costItemList) return;
    costItemList.map((costItem:CostItemModel) => {
      this.costItemNmList.push({text:costItem.itemNm, id:costItem.itemCd}); 
    });
    this._costItemList = costItemList;
  
  }

  @Input() set crncyRateList(crncyRateList:Array<CrncyRateModel>){
    if(!crncyRateList ) return;
    crncyRateList.map((crncyRate:CrncyRateModel) => {
      this.crncyCdList.push({text:crncyRate.crncyCd,id:crncyRate.crncyCd});
    });
    this._crncyRateList = crncyRateList;
  }
  
  @Input() set cnsltnQuotCstList(cnsltnQuotCstList:Array<CnsltnQuotCstModel>) {
    this._cnsltnQuotCstList = cnsltnQuotCstList;
    if(this._cnsltnQuotCstList && this._cnsltnQuotCstList.length > 0){    
      for(let i=0;i<this._cnsltnQuotCstList.length;i++){
        this.caculate(i, true, true);
      }
    }
  }

  @Input() set itemUnitList(itemUnitList:Array<any>) {
    if(this.cnsltnReq && this.cnsltnReq.reqTp == 0) {
      let cargo = this.cnsltnReq.crgoLst[this.cargoSeq];
      let item = _.find(itemUnitList, {id:'cntr'});
      item.name = cargo.crgoTp + '/' + cargo.crgoSz;
      // if(cargo && (cargo.crgoTp !== "OTHER")) {
      //   let item = _.find(itemUnitList, {id:'cntr'});
      //   item.name = cargo.crgoTp + '/' + cargo.crgoSz;
      // } else {
      //   let item = _.find(itemUnitList, {id:'cntr'});
      //   item.name = 'CNTR';
      // }
    }

    this._itemUnitList = itemUnitList;
  }


  @Input() set tabIndex(tabIndex: number) {
    if(this.cnsltnReq && this.cnsltnReq.reqTp == 0) {
      let cargo = this.cnsltnReq.crgoLst[tabIndex];
      let item = _.find(this._itemUnitList, {id:'cntr'});
      item.name = cargo.crgoTp + '/' + cargo.crgoSz;
      // if(cargo && (cargo.crgoTp !== "OTHER")) {
      //   let item = _.find(this._itemUnitList, {id:'cntr'});
      //   item.name = cargo.crgoTp + '/' + cargo.crgoSz;
      // } else {
      //   let item = _.find(this._itemUnitList, {id:'cntr'});
      //   item.name = 'CNTR';
      // }
    }
  }

  @Output() total: EventEmitter<any> = new EventEmitter();
  totalDebouncer: Subject<any> = new Subject();
  
  constructor(
    private fareService:FareService
  ){
    this.totalDebouncer
      .pipe(debounceTime(400))
      .subscribe(
        val => {
          this.total.emit(val);
        }
    );
  }

  ngOnInit(){
    
  }

  ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
    // for (let propName in changes) {
    //   let chng = changes[propName];
    //   let cur  = JSON.stringify(chng.currentValue);
    //   let prev = JSON.stringify(chng.previousValue);
    //   if(propName.indexOf("costItemList") > -1){
    //   }
    // }
  }

  getDefaultChargeWm(crgoLst, itemUnit, index){
    let totalCount = new bigdecimal.BigDecimal(0);
		let totalWeight = new bigdecimal.BigDecimal(0);
    let totalCbm = new bigdecimal.BigDecimal(0);
    
    let totalChargeWm = new bigdecimal.BigDecimal(0);
    
    crgoLst.map((crgo:CrgoLstModel)=>{
      let curCnt;
      if(crgo.count){
        totalCount = totalCount.add(new bigdecimal.BigDecimal(crgo.count));
        curCnt = new bigdecimal.BigDecimal(crgo.count);
      }

      let width:bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
      let height:bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
      let length:bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0');
      if(crgo.width) width = new bigdecimal.BigDecimal(crgo.width);
      if(crgo.height) height = new bigdecimal.BigDecimal(crgo.height);
      if(crgo.length) length = new bigdecimal.BigDecimal(crgo.length);
      
      if(this.cnsltnReq.transTp == 0){
        if(crgo.count && crgo.weight) totalWeight = totalWeight.add(new bigdecimal.BigDecimal(crgo.weight).multiply(curCnt));
      }else{
        let basic:bigdecimal.BigDecimal = new bigdecimal.BigDecimal('0.006');
        let cw:bigdecimal.BigDecimal = width.multiply(height.multiply(length));
        cw = cw.divide(basic, 25, bigdecimal.RoundingMode.HALF_UP());

        totalChargeWm = totalChargeWm.add(cw.multiply(curCnt));
        totalWeight = totalWeight.add(new bigdecimal.BigDecimal(crgo.weight).multiply(curCnt));
      
      }
      // if(crgo.cbm) totalCbm = totalCbm.add(new bigdecimal.BigDecimal(crgo.cbm).multiply(curCnt));
      if(crgo.cbm) {
        totalCbm = totalCbm.add(width.multiply(height.multiply(length.multiply(curCnt))));
      }
    });

    if(totalChargeWm.compareTo(totalWeight) == 1){
      totalWeight = totalChargeWm;
    }

    let cnt = new bigdecimal.BigDecimal(1);
    if(itemUnit.indexOf('cntr') > -1){
      if(this._cnsltnQuotCstList[index].crgoSeq == null){
        cnt = totalCount;
      }else{
        cnt = new bigdecimal.BigDecimal(crgoLst[this._cnsltnQuotCstList[index].crgoSeq].count);
      }
    }else if(itemUnit.indexOf('kg') > -1){
      cnt = totalWeight;
    }else if(itemUnit.indexOf("cbm") > -1){
      let divideThousand = totalWeight.divide(new bigdecimal.BigDecimal('1000'));
      if(divideThousand.compareTo(totalCbm) > 0) {
        cnt = divideThousand;
      } else {
        cnt = totalCbm;
      }

      if(cnt.doubleValue() < 1) {
        cnt = new bigdecimal.BigDecimal(1);
      }
    }

    let cntLast = new bigdecimal.BigDecimal(1);

    if(this.cnsltnReq.reqTp == 0) {
      cntLast = cnt.setScale(0, bigdecimal.RoundingMode.HALF_UP());;
    } else {
      cntLast = cnt.setScale(3, bigdecimal.RoundingMode.UP());
    }
    
    return cntLast;
  }


  plus(){
    let crgoSeq = null;
    if (this.cnsltnReq.reqTp == 0) crgoSeq = this.cargoSeq;
    this._cnsltnQuotCstList.push(new CnsltnQuotCstModel(this.fareTypeCd, this.cnsltnReq.reqNo, crgoSeq));
  }

  delete(index:number){
    this._cnsltnQuotCstList.splice(index,1);
    this.totalCaculate();
  }

  caculate(index:number, isNotSetCrgoSeq?:boolean, isFirst?:boolean){
    if(!isNotSetCrgoSeq){
      if(!this._cnsltnQuotCstList || !this._cnsltnQuotCstList[index].itemUnit || this._cnsltnQuotCstList[index].itemUnit.trim() != 'bl'){
        this._cnsltnQuotCstList[index].crgoSeq = this.cargoSeq;
      }else{
        this._cnsltnQuotCstList[index].crgoSeq = null;
      }
    }

    let unitCost = new bigdecimal.BigDecimal(0);
    let minUnitCost = new bigdecimal.BigDecimal(0);
    let chargeWm = new bigdecimal.BigDecimal(0);
    let itemUnit = this._cnsltnQuotCstList[index].itemUnit;

    if(!itemUnit) return;
    
    if(!this._cnsltnQuotCstList[index].unitCost) return;
    
    if(_.includes(String(this._cnsltnQuotCstList[index].unitCost), '-')) {
      if(_.startsWith(String(this._cnsltnQuotCstList[index].unitCost), '-')) {
        let stringUnitCost = String(this._cnsltnQuotCstList[index].unitCost);
        let unitCostNegative = stringUnitCost.substr(1, stringUnitCost.length);
        if(unitCostNegative) {
          unitCost = new bigdecimal.BigDecimal(unitCostNegative);
          unitCost = unitCost.negate();
        } else {
          return;
        }
      } else {
        let stringUnitCost = String(this._cnsltnQuotCstList[index].unitCost);
        
        let unitCostSplit = stringUnitCost.split('-');
        let newCost = unitCostSplit.join('');

        this._cnsltnQuotCstList[index].unitCost = Number(newCost);
        unitCost = new bigdecimal.BigDecimal(String(this._cnsltnQuotCstList[index].unitCost).replace(/,/gi, ""));
      }
    } else {
      if(this._cnsltnQuotCstList[index].unitCost) unitCost = new bigdecimal.BigDecimal(String(this._cnsltnQuotCstList[index].unitCost).replace(/,/gi, ""));
    }

    if(this._cnsltnQuotCstList[index].minUnitCost) minUnitCost = new bigdecimal.BigDecimal(String(this._cnsltnQuotCstList[index].minUnitCost).replace(/,/gi, ""));
    
    let tempChargeWm = this.getDefaultChargeWm(this.cnsltnReq.crgoLst, itemUnit, index);
    if(this._cnsltnQuotCstList[index].chargeWm) chargeWm = new bigdecimal.BigDecimal(String(this._cnsltnQuotCstList[index].chargeWm).replace(/,/gi, ""));
    else this._cnsltnQuotCstList[index].chargeWm = tempChargeWm;
    
    //비용 계산
    let totalCost = unitCost.multiply(tempChargeWm);
    
    if(chargeWm != null && chargeWm.doubleValue() > 0){
      totalCost = unitCost.multiply(chargeWm);
    }

    if(minUnitCost != null && minUnitCost != 0 && minUnitCost.doubleValue() > totalCost.doubleValue()){
      totalCost = minUnitCost.multiply(new bigdecimal.BigDecimal(1));
    }
    
    this._cnsltnQuotCstList[index].cost = totalCost.setScale(2, bigdecimal.RoundingMode.DOWN());
    if (this._cnsltnQuotCstList[index].crncyCd == this._cnsltnQuotCstList[index].subTtlCrncyCd) this._cnsltnQuotCstList[index].subTtlCost = this._cnsltnQuotCstList[index].cost.doubleValue();
    else this._cnsltnQuotCstList[index].subTtlCost = null;

    if (this._cnsltnQuotCstList[index].crncyCd == this._cnsltnQuotCstList[index].ttlCrncyCd) this._cnsltnQuotCstList[index].ttlCost = this._cnsltnQuotCstList[index].cost.doubleValue();
    else this._cnsltnQuotCstList[index].ttlCost = null;

    this.totalCaculate();
  }

  totalCaculate(){
    this.totalDebouncer.next(this.fareTypeNm);
  }

  private value:any = {};
  private _disabledV:string = '0';
  private disabled:boolean = false;
 
  private get disabledV():string {
    return this._disabledV;
  }
 
  private set disabledV(value:string) {
    this._disabledV = value;
    this.disabled = this._disabledV === '1';
  }
 
  public selected(value:any, index:number, type:string):void {
    if(type.indexOf('COST') > -1){
      this._cnsltnQuotCstList[index].itemCd = value.id;
      this._cnsltnQuotCstList[index].itemNm = value.text;
    }else if(type.indexOf('CURRENCT') > -1){
      this._cnsltnQuotCstList[index].crncyCd = value.id;
      this.caculate(index);
    }
  }
 
  public removed(value:any):void {
    
  }
 
  public typed(value:any):void {
    
  }
 
  // public refreshValue(value:any, index:number):void {
    
  //   // this._crncyRateList.map((crncyRate:CrncyRateModel)=>{
  //   //     if(crncyRate.crncyCd.indexOf(value) > -1 ){
  //   //       this._cnsltnQuotCstList[index].krwPerUnit = new bigdecimal.BigDecimal(crncyRate.krwPerUnit);
  //   //       this.caculate(index);
  //   //     }
  //   // });
  // }

  addComma(index:number,  event?){
    if(event){
      if(event.target){
        if(event.target.id.indexOf('unitCost') > -1 ) this._cnsltnQuotCstList[index].unitCost = Util.numberWithCommas(event.target.value);
        if(event.target.id.indexOf('minUnitCost') > -1 ) this._cnsltnQuotCstList[index].minUnitCost = Util.numberWithCommas(event.target.value);
        if(event.target.id.indexOf('chargeWm') > -1 ) this._cnsltnQuotCstList[index].chargeWm = Util.numberWithCommas(event.target.value);
      }else{
        this._cnsltnQuotCstList[index].unitCost = Util.numberWithCommas(this._cnsltnQuotCstList[index].unitCost);
        this._cnsltnQuotCstList[index].minUnitCost = Util.numberWithCommas(this._cnsltnQuotCstList[index].minUnitCost);
        this._cnsltnQuotCstList[index].chargeWm = Util.numberWithCommas(this._cnsltnQuotCstList[index].chargeWm);
      }
    }
  }

  removeCommas (index:number,  event?){
    if(event){
      if(event.target){
        if(event.target.id.indexOf('unitCost') > -1 ) this._cnsltnQuotCstList[index].unitCost = event.target.value.replace(/,/gi, ""); 
        if(event.target.id.indexOf('minUnitCost') > -1 ) this._cnsltnQuotCstList[index].minUnitCost = event.target.value.replace(/,/gi, ""); 
        if(event.target.id.indexOf('chargeWm') > -1 ) this._cnsltnQuotCstList[index].chargeWm = event.target.value.replace(/,/gi, ""); 
      }
    }
  }
}





// WEBPACK FOOTER //
// ./src/app/containers/fare/rate/detail/fare-rate-detail-list.ts